"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmptyDataRow = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const fa_1 = require("react-icons/fa");
function EmptyDataRow(props) {
    const { columns, text } = props;
    return ((0, jsx_runtime_1.jsx)("tr", { children: (0, jsx_runtime_1.jsxs)("td", { colSpan: columns.length, style: { textAlign: 'center', padding: '0.5em' }, children: [(0, jsx_runtime_1.jsx)(fa_1.FaRegEyeSlash, { style: {
                        display: 'inline-block',
                        margin: '0px 10px',
                        fontSize: '1.5em',
                        color: '#6a6a6a',
                    } }), (0, jsx_runtime_1.jsx)("span", { style: { fontSize: '1.1em' }, children: text })] }) }));
}
exports.EmptyDataRow = EmptyDataRow;
